import { Role } from "elephant-web/gql";

// These allowlists mirror the @authUserRole directives guarding the sync
// handlers in api-imaging-study, per handler. A role absent from a directive
// gets FORBIDDEN from the backend, so that side of the replication must never
// register for it — a failed pull flips the patient-history "Update failed"
// banner.

/** pullImagingStudy, pushImagingStudy and pullImagingInstance all carry this same directive. */
export const IMAGING_REPLICATION_ROLES: readonly Role[] = [
  Role.Sonographer,
  Role.Performer,
  Role.Reviewer,
  Role.QaAdmin,
  Role.ProgramAdmin,
];

export const EPOCUS_ENCOUNTER_PULL_ROLES: readonly Role[] = [
  Role.Sonographer,
  Role.Performer,
  Role.Reviewer,
  Role.QaAdmin,
  Role.ProgramAdmin,
];

export const EPOCUS_ENCOUNTER_PUSH_ROLES: readonly Role[] = [
  Role.Sonographer,
  Role.Performer,
  Role.Reviewer,
  Role.QaAdmin,
  Role.ProgramAdmin,
];

/** pullEpocusExam and pushEpocusExam carry the same directive. */
export const EPOCUS_EXAM_REPLICATION_ROLES: readonly Role[] = [
  Role.Sonographer,
  Role.Performer,
  Role.Reviewer,
  Role.QaAdmin,
  Role.ProgramAdmin,
];

/** pullEpocusConsentDocument, pullEpocusPatientConsent and pushEpocusPatientConsent all carry the same directive. */
export const EPOCUS_CONSENT_REPLICATION_ROLES: readonly Role[] = [
  Role.Sonographer,
  Role.Performer,
  Role.Reviewer,
  Role.QaAdmin,
  Role.ProgramAdmin,
];

/**
 * Probe associations are self-service: every ePOCUS role that can be a
 * performer, or oversee them, both reads and writes its own links, so pull and
 * push carry the same directive.
 */
export const EPOCUS_PROBE_ASSOCIATION_ROLES: readonly Role[] = [
  Role.Sonographer,
  Role.Performer,
  Role.Reviewer,
  Role.QaAdmin,
  Role.ProgramAdmin,
];

export const EPOCUS_PROGRAM_PULL_ROLES: readonly Role[] = [
  Role.Sonographer,
  Role.Performer,
  Role.Reviewer,
  Role.QaAdmin,
  Role.ProgramAdmin,
  Role.Elephant,
  Role.Root,
  Role.Admin,
];

export const isReplicationRoleAllowed = (
  allowlist: readonly Role[],
  role: Role | undefined,
): boolean => role !== undefined && allowlist.includes(role);
